import { Button, useTheme } from '@mui/material';
import SuccessCheck from './SuccessCheck';
import FailureCross from './FailureCross';
import { tokens } from '../../global/theme/tokens';

const FeedbackButton = ({
  children,
  onClick = () => {},
  className,
  isLoading = false,
  success = false,
  variant = '',
  sx: sxProp = {},
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Button
      className={className + ' flex justify-center items-center gap-2'}
      onClick={onClick}
      variant={variant}
      sx={{
        bgcolor: colors.info + '30',
        border: '1px solid ' + colors.info + '80',
        ':hover': { bgcolor: colors.info + '50' },
        ...sxProp,
      }}
    >
      {children}
      {isLoading && <span class="loader" />}
      {!isLoading && success === true && (
        <SuccessCheck width="25" height="25" />
      )}
      {!isLoading && success === false && (
        <FailureCross width="25" height="25" />
      )}
    </Button>
  );
};

export default FeedbackButton;
